import { render, staticRenderFns } from "./PatientMeasurements.vue?vue&type=template&id=3c66c49a&scoped=true&"
import script from "./PatientMeasurements.vue?vue&type=script&lang=js&"
export * from "./PatientMeasurements.vue?vue&type=script&lang=js&"
import style0 from "./PatientMeasurements.vue?vue&type=style&index=0&id=3c66c49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c66c49a",
  null
  
)

export default component.exports